var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.100586 1H19.8996","stroke":"#07162C","strokeWidth":"2"}));
}

Minus.defaultProps = {"width":"20","height":"2","viewBox":"0 0 20 2","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
